import React from 'react';
import { filterCategories } from 'src/areas/landing-page/filter-categories';
import { Product, FeaturedProductsFragment } from 'src/types';
import { ProductsSection } from '../products-section';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  featuredProducts?: FeaturedProductsFragment['featuredProducts'];
  landingPage?: boolean;
};

const FeaturedProducts: React.FC<Props> = props => {
  const { featuredProducts } = props;
  if (!featuredProducts) return null;

  const featuredProductsItems = filterCategories(
    featuredProducts.products as Product[]
  );

  const linkPath = () => {
    if (!featuredProducts.linkUrl) return undefined;
    try {
      // linkUrl is a URL
      const fullURL = featuredProducts.linkUrl.startsWith('www')
        ? `https://${featuredProducts.linkUrl}`
        : featuredProducts.linkUrl;
      return new URL(fullURL).pathname;
    } catch (e) {
      // linkUrl is a path
      return featuredProducts.linkUrl;
    }
  };

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.FEATURED_PRODUCTS_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.FEATURED_PRODUCTS_PRODUCTS_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ProductsSection
      products={featuredProductsItems}
      title={featuredProducts.title ? featuredProducts.title : ''}
      linkTitle={
        featuredProducts.linkTitle ? featuredProducts.linkTitle : undefined
      }
      linkPath={linkPath()}
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
      landingPage={props.landingPage}
    />
  );
};

export default FeaturedProducts;
